export default "__VITE_ASSET__BwGNMEUH__"